import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { endpoint } from "../../api/endpoint";
import { apiHandler } from "../../api";
import toast from "react-hot-toast";
import { useNavigate } from "react-router";

const useModelDetail = (params) => {
  const { id } = params;
  const navigate = useNavigate();
  const { authData, storeId } = useSelector((state) => state.loginSlice);
  const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] =
    useState(false);
  // const [bodyTypes, setBodyTypes] = useState([]);
  const [selectedImage, setSelectedImage] = useState("");
  const [modelDetails, setModelDetails] = useState({});
  const [image, setImage] = useState(null);
  // const [imageFile, setImageFile] = useState(null);
  const [products, setProducts] = useState([]);
  const [isImageUploaded, setIsImageUploaded] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [imageLoader, setImageLoader] = useState(false);
  const [edit, setEdit] = useState(false);
  const [imgWidth, setImgWidth] = useState("");
  // const [modelImages, setModelImages] = useState([]);
  const handleRemoveImage = () => {
    setEdit(true);
    setIsLoading(false);
    setImage(null);
    setIsImageUploaded(false);
  };
  const dispatch = useDispatch();

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    // setImageFile(file);
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      await getCoordinates(file, imageUrl);
    }
  };

  const calculatePosition = (
    coOrdinates,
    product,
    newwidth,
    newheight,
    bodyType,
    prodHeight,
    prodWidth
  ) => {
    if (product.iBodyTypeId === 3) {
      const positions = [];
      const fingerNames = Object.keys(coOrdinates.coordinates).filter(
        (key) => key !== "hand" && key !== "sUUID" && key != "sImageURL"
      );
      console.log(coOrdinates, "coOrdinates");

      fingerNames.forEach((finger) => {
        const fingerData = coOrdinates.coordinates[finger][0];

        if (fingerData) {
          let [leftX, leftY] = fingerData.left;

          leftX = leftX * newwidth;
          leftY = leftY * newheight;

          let [rightX, rightY] = fingerData.right;
          rightX = rightX * newwidth;
          rightY = rightY * newheight;

          let centerX = (leftX + rightX) / 2;
          let centerY = (leftY + rightY) / 2;

          const length = Math.sqrt(
            Math.pow(rightX - leftX, 2) + Math.pow(rightY - leftY, 2)
          );
          const aspectRatio =
            prodHeight > 0 && prodWidth > 0 ? prodHeight / prodWidth : 1;
          const angle =
            (Math.atan2(rightY - leftY, rightX - leftX) * 180) / Math.PI;

          positions.push({
            left: centerX,
            top: centerY,
            rotationAngle: angle,
            height: length * aspectRatio,
            width: length + length * 0.1,
            leftX,
            leftY,
            rightX,
            rightY,
            centerX,
            centerY,
          });
        }
      });

      return positions;
    } else if (product.iBodyTypeId === 1) {
      if (coOrdinates) {
        let coOrdinates1 = coOrdinates.wrist
          ? coOrdinates.wrist.coordinates[0]
          : coOrdinates.wrist;
        const handCooridntaes = coOrdinates.hand;
        let hand = coOrdinates.wrist
          ? coOrdinates.wrist.hand
          : coOrdinates.hand;
        let [leftX, leftY] = coOrdinates1.left;
        leftX = leftX * newwidth;
        leftY = leftY * newheight;
        const aspectRatio = prodHeight / prodWidth;
        let [rightX, rightY] = coOrdinates1.right;
        rightX = rightX * newwidth;
        rightY = rightY * newheight;

        let centerX = (leftX + rightX) / 2;
        let centerY = (leftY + rightY) / 2;

        const length = Math.sqrt(
          Math.pow(rightX - leftX, 2) + Math.pow(rightY - leftY, 2)
        );

        const angle =
          hand === "right"
            ? Math.abs(
                (Math.atan2(rightY - leftY, rightX - leftX) * 180) / Math.PI
              )
            : Math.abs(
                (Math.atan2(leftY - rightY, leftX - rightX) * 180) / Math.PI
              );
        return {
          left: centerX,
          top: centerY,
          rotationAngle: angle,
          height: length * aspectRatio,
          width: length + length * 0.1,
          leftX,
          leftY,
          rightX,
          rightY,
          centerX,
          centerY,
        };
      }
    } else if (product.iBodyTypeId === 4) {
      let neckCoordinates = coOrdinates?.neck_coordinates?.neck_wide
        ? coOrdinates?.neck_coordinates?.neck_wide
        : coOrdinates?.neck_mask_wide;
      let [leftX, leftY] = neckCoordinates.left_point;
      leftX = leftX * newwidth;
      leftY = leftY * newheight;

      let [rightX, rightY] = neckCoordinates.right_point;
      rightX = rightX * newwidth;
      rightY = rightY * newheight;

      let centerX = (leftX + rightX) / 2;
      let centerY = (leftY + rightY) / 2;

      const length = Math.sqrt(
        Math.pow(rightX - leftX, 2) + Math.pow(rightY - leftY, 2)
      );

      let angle = (Math.atan2(rightY - leftY, rightX - leftX) * 180) / Math.PI;

      if (Math.abs(angle) < 5) {
        angle = 0;
      }

      return {
        left: centerX - length / 2 - length * 0.1,
        top: centerY - length / 2 - length * 0.1,
        rotationAngle: angle,
        height: length + length * 0.2,
        width: length + length * 0.2,
        leftX,
        leftY,
        rightX,
        rightY,
        centerX,
        centerY,
      };
    } else if (product.iBodyTypeId === 2) {
      let earCoordinates = coOrdinates?.ear_coordinates;
      let positions = [];

      earCoordinates.forEach((earCoord) => {
        if (earCoord) {
          const [earX, earY] = earCoord;
          const x = earX * newwidth;
          const y = earY * newheight;
          let zoomfactor = coOrdinates.zoom_factor;
          const aspectRatio = product?.dProductHeight / product?.dProductWidth;
          const productImageHeight = product?.dProductHeight * zoomfactor;

          const productImageWidth =
            (product?.dProductHeight * zoomfactor) / aspectRatio;
          positions.push({
            left: x,
            top: y,
            height:
              aspectRatio && product?.dProductHeight && zoomfactor
                ? productImageHeight
                : 60,
            width:
              aspectRatio && product?.dProductHeight && zoomfactor
                ? productImageWidth
                : 60,
            leftX: x,
            leftY: y,
          });
        }
      });

      return positions;
    } else {
      console.error("Finger data not found for the current finger.");
    }
  };

  const handleDebugVersion = (imgwidth, imgheight) => {
    const demoDiv = document.querySelector(".demo");
    let height, width;
    console.log(selectedImage);

    if (!demoDiv) {
      console.error("Element with class 'demo' not found in the DOM.");
      return;
    }
    demoDiv.innerHTML = "";

    if (demoDiv.innerHTML) {
      demoDiv.innerHTML = "";
    } else {
      if (
        parseInt(selectedImage.iBodyTypeId) === 1 ||
        selectedImage.iBodyTypeId === 1
      ) {
        const wristCoordinates = JSON.parse(selectedImage.sCoordinate).wrist
          ? JSON.parse(selectedImage.sCoordinate).wrist
          : JSON.parse(selectedImage.sCoordinate);

        if (wristCoordinates) {
          let [leftX, leftY] = wristCoordinates.left;
          leftX = leftX * imgwidth;
          leftY = leftY * 500;

          let [rightX, rightY] = wristCoordinates.right;
          rightX = rightX * imgwidth;
          rightY = rightY * 500;

          let centerX = (leftX + rightX) / 2;
          let centerY = (leftY + rightY) / 2;

          demoDiv.innerHTML = "";

          const createDot = (x, y, color) => {
            let dot = document.createElement("div");
            dot.style.position = "absolute";
            dot.style.backgroundColor = color;
            dot.style.width = "5px";
            dot.style.height = "5px";
            dot.style.top = `${y}px`;
            dot.style.left = `${x}px`;
            dot.style.zIndex = 2;
            dot.style.borderRadius = "50%";
            return dot;
          };

          demoDiv.appendChild(createDot(leftX, leftY, "orange"));
          demoDiv.appendChild(createDot(rightX, rightY, "green"));
          demoDiv.appendChild(createDot(centerX, centerY, "tomato"));
        } else {
          console.log("Finger data not found for the current finger.");
        }
      } else if (parseInt(selectedImage.iBodyTypeId) === 3) {
        const fingerCoordinates = JSON.parse(selectedImage.sCoordinate);
        if (fingerCoordinates) {
          ["Index", "Middle", "Pinky", "Ring"].forEach((finger, index) => {
            const currentFingerData =
              fingerCoordinates?.[finger] ||
              fingerCoordinates[finger.toLowerCase()];
            if (currentFingerData) {
              let [leftX, leftY] = currentFingerData.left;
              leftX = leftX * imgwidth;
              leftY = leftY * 500;
              let [rightX, rightY] = currentFingerData.right;
              rightX = rightX * imgwidth;
              rightY = rightY * 500;
              let centerX = (leftX + rightX) / 2;
              let centerY = (leftY + rightY) / 2;
              const demoDiv = document.querySelector(`.demo${index}`);

              demoDiv.innerHTML = "";
              const createDot = (x, y, color) => {
                let dot = document.createElement("div");
                dot.style.position = "absolute";
                dot.style.backgroundColor = color;
                dot.style.width = "5px";
                dot.style.height = "5px";
                dot.style.top = `${y}px`;
                dot.style.left = `${x}px`;
                dot.style.zIndex = 2;
                dot.style.borderRadius = "50%";
                return dot;
              };
              demoDiv.appendChild(createDot(leftX, leftY, "orange"));
              demoDiv.appendChild(createDot(rightX, rightY, "green"));
              demoDiv.appendChild(createDot(centerX, centerY, "tomato"));
            } else {
              console.error("Finger data not found for the current finger.");
            }
          });
        }
      } else if (parseInt(selectedImage.iBodyTypeId) === 2) {
        const neckCoordinates = JSON.parse(selectedImage?.sCoordinate)
          ?.neck_coordinates?.neck_wide
          ? JSON.parse(selectedImage?.sCoordinate)?.neck_coordinates?.neck_wide
          : JSON.parse(selectedImage?.sCoordinate)?.neck_mask_wide;

        const earCoordinates = JSON.parse(
          selectedImage.sCoordinate
        )?.ear_coordinates;

        demoDiv.innerHTML = "";

        const createDot = (x, y, color) => {
          let dot = document.createElement("div");
          dot.style.position = "absolute";
          dot.style.backgroundColor = color;
          dot.style.width = "5px";
          dot.style.height = "5px";
          dot.style.borderRadius = "50%";
          dot.style.top = `${y}px`;
          dot.style.left = `${x}px`;
          dot.style.zIndex = 2;
          return dot;
        };

        if (neckCoordinates) {
          let [leftX, leftY] = neckCoordinates.left_point;
          leftX = leftX * 300;
          leftY = leftY * 500;

          let [rightX, rightY] = neckCoordinates.right_point;
          rightX = rightX * 300;
          rightY = rightY * 500;

          let centerX = (leftX + rightX) / 2;
          let centerY = (leftY + rightY) / 2;

          demoDiv.appendChild(createDot(leftX, leftY, "orange"));
          demoDiv.appendChild(createDot(rightX, rightY, "green"));
          demoDiv.appendChild(createDot(centerX, centerY, "tomato"));
        }

        if (earCoordinates) {
          if (earCoordinates[0]) {
            let [leftEarX, leftEarY] = earCoordinates[0];
            leftEarX = leftEarX * imgwidth;
            leftEarY = leftEarY * 500;

            demoDiv.appendChild(createDot(leftEarX, leftEarY, "black"));
          }

          if (earCoordinates[1]) {
            let [rightEarX, rightEarY] = earCoordinates[1];
            rightEarX = rightEarX * imgwidth;
            rightEarY = rightEarY * 500;

            demoDiv.appendChild(createDot(rightEarX, rightEarY, "black"));
          }
        }
      } else if (parseInt(selectedImage.iBodyTypeId) === 4) {
        const neckCoordinates = JSON.parse(selectedImage?.sCoordinate)
          ?.neck_coordinates?.neck_wide
          ? JSON.parse(selectedImage?.sCoordinate)?.neck_coordinates?.neck_wide
          : JSON.parse(selectedImage?.sCoordinate)?.neck_mask_wide;

        const earCoordinates = JSON.parse(
          selectedImage.sCoordinate
        )?.ear_coordinates;

        demoDiv.innerHTML = "";

        const createDot = (x, y, color) => {
          let dot = document.createElement("div");
          dot.style.position = "absolute";
          dot.style.backgroundColor = color;
          dot.style.width = "5px";
          dot.style.height = "5px";
          dot.style.borderRadius = "50%";
          dot.style.top = `${y}px`;
          dot.style.left = `${x}px`;
          dot.style.zIndex = 2;
          return dot;
        };

        if (neckCoordinates) {
          let [leftX, leftY] = neckCoordinates.left_point;
          leftX = leftX * imgwidth;
          leftY = leftY * 500;

          let [rightX, rightY] = neckCoordinates.right_point;
          rightX = rightX * imgwidth;
          rightY = rightY * 500;

          let centerX = (leftX + rightX) / 2;
          let centerY = (leftY + rightY) / 2;

          demoDiv.appendChild(createDot(leftX, leftY, "orange"));
          demoDiv.appendChild(createDot(rightX, rightY, "green"));
          demoDiv.appendChild(createDot(centerX, centerY, "tomato"));
        }

        if (earCoordinates) {
          if (earCoordinates[0]) {
            let [leftEarX, leftEarY] = earCoordinates[0];
            leftEarX = leftEarX * imgwidth;
            leftEarY = leftEarY * 500;

            demoDiv.appendChild(createDot(leftEarX, leftEarY, "black"));
          }

          if (earCoordinates[1]) {
            let [rightEarX, rightEarY] = earCoordinates[1];
            rightEarX = rightEarX * imgwidth;
            rightEarY = rightEarY * 500;

            demoDiv.appendChild(createDot(rightEarX, rightEarY, "black"));
          }
        }
      }
    }
  };

  const handleImageLoad = (imageUrl, callback) => {
    const img = new Image();
    img.src = imageUrl;

    img.onload = () => {
      const width = img.width;
      const height = img.height;
      console.log("Image Loaded - Width:", width, "Height:", height);

      // Call the debug function with the width and height
      callback(width, height);
    };

    img.onerror = () => {
      console.error("Failed to load image:", imageUrl);
    };
  };

  const handleDebugWrapper = () => {
    if (selectedImage?.sURL) {
      handleImageLoad(selectedImage.sURL, (width, height) => {
        const newWidth = (500 * width) / height;

        handleDebugVersion(newWidth, 500);
      });
    } else {
      console.error("No image URL found in selectedImage.");
    }
  };

  const fetchModelDetails = async () => {
    try {
      const url = `${endpoint.GET_MODEL_BY_ID}/${id}`;
      const response = await apiHandler({
        url: url,
        method: "GET",
        authToken: authData,
        storeId,
        dispatch,
      });

      if (response.data.status === "success") {
        setModelDetails(response.data.data.model);

        const aImages = JSON.parse(response.data.data.model.aImageJson);
        setSelectedImage(aImages[0]);
        const coordinates = JSON.parse(aImages[0].sCoordinate);

        // Create an image object to wait for it to load
        const img = new Image();
        img.src = aImages[0].sURL;

        img.onload = () => {
          const height = img.height;
          const width = img.width;
          const newWidth = (500 * width) / height;

          console.log("newWidth", newWidth);
          setImgWidth(newWidth);

          // Now map products after image has loaded
          const updatedProducts = response.data.data.products.map(
            (productItem) => {
              const productHeight = coordinates?.norm_prod_height?.find(
                (cord) => cord.sStoreProductId === productItem?.iProductId
              )?.dNormProductHeightStd;
              const zoomFactor = coordinates?.zoom_factor;

              const position = calculatePosition(
                coordinates,
                productItem,
                newWidth,
                500,
                aImages[0].iBodyTypeId,
                productItem.fHeight,
                productItem.fWidth
              );

              return { ...productItem, position };
            }
          );

          setProducts(updatedProducts);
        };

        img.onerror = () => {
          console.error("Image failed to load:", response.data.data.model.sURL);
        };
      }
    } catch (error) {
      console.log("Error fetching product details", error);
    }
  };

  const handleDeleteClick = () => {
    setIsDeleteConfirmationOpen(true);
  };

  const handleModelImageChange = (img) => {
    setSelectedImage(img);
    const coordinates = JSON.parse(img.sCoordinate);
    const updatedProducts = products.map((productItem) => {
      const productHeight = coordinates?.norm_prod_height?.find(
        (cord) => cord.sStoreProductId === productItem?.iProductId
      )?.dNormProductHeightStd;
      const zoomFactor = coordinates?.zoom_factor;
      const image = img.sURL;
      let height, width;
      const imageUrl = new Image();
      imageUrl.src = image;
      (height = imageUrl.height), (width = imageUrl.width);
      const newwidth = (500 * width) / height;
      // setImgWidth(newwidth);
      console.log(newwidth);

      const position = calculatePosition(
        coordinates,
        productItem,
        newwidth,
        500,
        img.iBodyTypeId
      );

      return { ...productItem, position };
    });

    setProducts(updatedProducts);
  };

  const handleDelete = async (id) => {
    try {
      const url = `${endpoint.DELETE_MODEL}${id}`;
      const response = await apiHandler({
        url: url,
        method: "DELETE",
        authToken: authData,
        storeId,
        dispatch,
      });
      if (response.data.status === "success") {
        toast.success("Model Deleted successfully");
        navigate("/modelsandbox");
      }
    } catch (error) {
      console.log("Error deleting the model", error);
    }
  };

  useEffect(() => {
    fetchModelDetails();
  }, []);

  const getCoordinates = async (file, imageUrl) => {
    setIsLoading(true);
    const timeout = new Promise((_, reject) =>
      setTimeout(() => reject(new Error("Request timed out")), 30000)
    );

    const fetchCoordinates = async () => {
      const formData = new FormData();
      formData.append("ModelImage", file);
      // formData.append("bAuto", modelDetails.vtoType === "automatic");
      const bodyType = modelDetails.sBodyType;

      const images = [
        {
          name: file.name,
          sName: bodyType,
        },
      ];

      // formData.append("sName", bodyType.sName);

      formData.append("aImagesJson", JSON.stringify(images));

      const response = await apiHandler({
        url: endpoint.GET_CORDINATES,
        method: "POST",
        data: formData,
        authToken: authData,
        storeId,
        dispatch,
      });

      return response;
    };

    try {
      const response = await Promise.race([fetchCoordinates(), timeout]);
      if (response.data.status === "success") {
        if (response.data.data[0]?.sCoordinates !== undefined) {
          setIsImageUploaded(true);
          setModelDetails({
            ...modelDetails,
            ...response.data.data[0],
            sCoordinate: response.data.data[0].sCoordinates,
            sTag: response.data.data[0].sTagName,
          });
          setImage(imageUrl);
          const coordinates = JSON.parse(response.data.data[0].sCoordinates);
          const updatedProducts = products.map((productItem) => {
            const productHeight = coordinates?.norm_prod_height?.find(
              (cord) => cord.sStoreProductId === productItem?.iProductId
            )?.dNormProductHeightStd;
            const zoomFactor = coordinates?.zoom_factor;
            let height, width;
            const img = new Image();
            img.src = response.data.data.galleryDetails.sURL;
            (height = img.height), (width = img.width);
            const newwidth = (500 * width) / height;
            setImgWidth(newwidth);
            console.log("newwidth", newwidth);

            const position = calculatePosition(
              coordinates,
              productItem,
              imgWidth,
              500,
              modelDetails.iBodyTypeId
            );

            return { ...productItem, position };
          });
          setProducts(updatedProducts);
        } else {
          setErrorMessage("Please change the image");
        }

        setIsLoading(false);
      } else {
        setErrorMessage(response.data.message);
      }
    } catch (error) {
      setIsLoading(false);
      if (error.message === "Request timed out") {
        setErrorMessage("Please change the image");
      } else {
        console.error("Error fetching coordinates", error);
      }
    }
  };

  const updateModel = async () => {
    try {
      setImageLoader(true);

      const response = await apiHandler({
        url: `${endpoint.UPDATE_MODEL}/${id}`,
        method: "PUT",
        authToken: authData,
        data: {
          sName: modelDetails.sModelName,
          iGenderId: parseInt(modelDetails.iGenderId),
          iBodyTypeId: parseInt(modelDetails.iBodyTypeId),
          sURL: modelDetails.sURL,
          sCoordinate: modelDetails.sCoordinate,
          sTag: modelDetails.sTag,
          // bIsActive: modelDetailsisActive ? 1 : 0,
        },
        storeId,
        dispatch,
      });

      setIsImageUploaded(true);
      if (response.data.status === "success") {
        fetchModelDetails();
        setEdit(false);
        toast.success("Model updated successfully");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log("error creating model", error);
    } finally {
      setImageLoader(false);
    }
  };

  //   useEffect(() => {
  //     if (products.length && modelDetails) {
  //       const coordinates = JSON.parse(modelDetails.sCoordinate);

  //       if (coordinates) {
  //         const updatedProducts = products.map((productItem) => {
  //           const productHeight = coordinates?.norm_prod_height?.find(
  //             (cord) => cord.iProductId === productItem?.iProductId
  //           )?.dNormProductHeightStd;
  //           const zoomFactor = coordinates?.zoom_factor;

  //           const position = calculatePosition(
  //             coordinates,
  //             productItem,
  //             productHeight,
  //             zoomFactor
  //           );

  //           return { ...productItem, position };
  //         });

  //         setProducts(updatedProducts);
  //       }
  //     }
  //   }, [modelDetails]);

  useEffect(() => {
    handleDebugWrapper();
  }, [selectedImage]);

  return {
    modelDetails,
    setModelDetails,
    products,
    isImageUploaded,
    image,
    errorMessage,
    handleRemoveImage,
    handleImageChange,
    handleDelete,
    setIsDeleteConfirmationOpen,
    navigate,
    isDeleteConfirmationOpen,
    handleDeleteClick,
    isLoading,
    imageLoader,
    updateModel,
    edit,
    selectedImage,
    setSelectedImage,
    handleModelImageChange,
    imgWidth,
  };
};

export default useModelDetail;
